import { PostRequest, PutRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useTranslation } from "react-i18next"
import { ERequestType } from "../../Enum/ERequestType"
import { EDeliveryStatusType } from "../../Enum/EDeliveryStatusType"

export const useSaveDelivery = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleAssignDelivery = async (
    payload: {
      orderId: number
      courierEntityId?: string
      pickupLatitude?: number
      pickupLongitude?: number
      dropoffLatitude?: number
      dropoffLongitude?: number
      hasAcceptedFinancialResponsibility: boolean
    },
    onSuccess?: () => void,
  ) => {
    try {
      enableLoad()

      const response = await PostRequest<boolean>(API_ROUTES.DELIVERY.ASSIGN, payload)

      if (response.success) {
        onSuccess && onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const handleCancelSearchDelivery = async (deliveryId: number, onSuccess?: () => void) => {
    try {
      enableLoad()

      const response = await PutRequest<boolean>(`${API_ROUTES.DELIVERY.BASE}/${deliveryId}/cancel-search`, {})

      if (response.success) {
        onSuccess && onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const handleUpdateDeliveryStatus = async (
    deliveryId: number,
    status: EDeliveryStatusType,
    onSuccess?: () => void,
  ) => {
    try {
      enableLoad()

      const response = await PutRequest<boolean>(
        `${API_ROUTES.DELIVERY.BASE}/${deliveryId}/status`,
        { status },
        ERequestType.Courier,
      )

      if (response.success) {
        onSuccess && onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleAssignDelivery,
    handleCancelSearchDelivery,
    handleUpdateDeliveryStatus,
  }
}
